// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.amenities.RentalManagerUserPropertyAmenityV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyAmenityV2WebApiHandler_create,
  RentalManagerUserPropertyAmenityV2WebApiHandler_delete,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyAmenityCreateResponseV2WebDto,
  UserPropertyAmenityCreateV2RequestDto,
  UserPropertyAmenityDeleteV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyAmenityV2WebApiHandler_create_Args {
  postData: UserPropertyAmenityCreateV2RequestDto;
}

export type RentalManagerUserPropertyAmenityV2WebApiHandler_create_Options = UseMutationOptions<
  UserPropertyAmenityCreateResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyAmenityV2WebApiHandler_create_Args
>;

/**
 * Create a free text property amenity
 */
export const useRentalManagerUserPropertyAmenityV2WebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyAmenityV2WebApiHandler_create_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyAmenityV2WebApiHandler_create_Args) =>
      RentalManagerUserPropertyAmenityV2WebApiHandler_create(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyAmenityV2WebApiHandler_delete_Args {
  postData: UserPropertyAmenityDeleteV2RequestDto;
}

export type RentalManagerUserPropertyAmenityV2WebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyAmenityV2WebApiHandler_delete_Args
>;

/**
 * Delete a free text property amenity
 */
export const useRentalManagerUserPropertyAmenityV2WebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyAmenityV2WebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyAmenityV2WebApiHandler_delete_Args) =>
      RentalManagerUserPropertyAmenityV2WebApiHandler_delete(args.postData, httpClient),
  });
};
